import React, { useState, useEffect } from "react";
import { Button, Icon } from "@culturehq/components";

import { Organization } from "chq";
import { Trans } from "app/utils";
import { HandleMediaChange } from "components/stories/post-stories-v2/types";
import { usePostStoryContext } from "components/stories/post-stories-v2/contexts/PostStoryContext";
import EffectsSDKCameraRecorder from "./effectsSDK/EffectsSDKCameraRecorder";
import RegularCameraRecorder from "./RegularCameraRecorder";

interface CameraRecorderProps {
  organization: Organization;
  className?: string;
  initialOpen?: boolean;
  script?: string;
  onOpen?: () => void;
  onVideoRecorded: (file: HandleMediaChange) => Promise<void>;
}

const CameraRecorder: React.FC<CameraRecorderProps> = ({
  className, initialOpen = false, organization, onVideoRecorded, script, onOpen
}) => {
  const [loading, setLoading] = useState(true);
  const [newCameraRecorder, setNewCameraRecorder] = useState(false);
  const { state: { webVideoRecorded } } = usePostStoryContext();
  const labels = { retake: "Retake video", record: "Record video" };
  const [label, setLabel] = useState<string>(webVideoRecorded ? labels.retake : labels.record);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://effectssdk.ai/sdk/web/3.5.1/tsvb-web.js";
    script.async = true;

    script.onload = () => {
      setNewCameraRecorder(true);
      setLoading(false);
    };

    script.onerror = () => {
      setLoading(false);
    };

    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  useEffect(() => {
    setLabel(webVideoRecorded ? labels.retake : labels.record);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [webVideoRecorded]);

  if (loading) {
    return (
      <Button className={className} disabled>
        <Icon icon="video-camera-filled" />
        <Trans>{label}</Trans>
      </Button>
    );
  }

  if (newCameraRecorder) {
    return (
      <EffectsSDKCameraRecorder
        organization={organization}
        className={className}
        initialOpen={initialOpen}
        script={script}
        onOpen={onOpen}
        onVideoRecorded={onVideoRecorded}
      >
        <Icon icon="video-camera-filled" />
        <Trans>{label}</Trans>
      </EffectsSDKCameraRecorder>
    );
  }

  return (
    <RegularCameraRecorder
      className={className}
      initialOpen={initialOpen}
      onVideoRecorded={onVideoRecorded}
      script={script}
      onOpen={onOpen}
    >
      <Icon icon="video-camera-filled" />
      <Trans>{label}</Trans>
    </RegularCameraRecorder>
  );
};

export default CameraRecorder;
